import { BehaviorSubject } from 'rxjs'

const layoutRootElementSubject = new BehaviorSubject<HTMLDivElement | null>(null)

export const layoutRootElement$ = layoutRootElementSubject.asObservable()

export const setLayoutRootElement = (element: HTMLDivElement | null) =>
  layoutRootElementSubject.next(element)
